import { Badge } from "@mantine/core";
import type { ReactNode } from "react";

interface ISSBadge {
  color: { background: string; border?: string; text: string };
  leftSection?: ReactNode;
  children: ReactNode;
  capitalize?: boolean;
  className?: string;
}

const SSBadge: React.FC<ISSBadge> = ({
  color,
  children,
  leftSection,
  capitalize = true,
  className = "",
}) => {
  return (
    <Badge
      className={`h-6 px-1 ${capitalize ? "capitalize" : "normal-case"} ${className}`}
      color={color.text}
      leftSection={leftSection}
      radius="md"
      classNames={{
        section: "m-0 h-full",
        label: "font-inter",
      }}
      style={{
        borderColor: color.border,
        background: color.background,
      }}
      variant="light"
      unselectable="on"
      autoCapitalize="off"
    >
      {children}
    </Badge>
  );
};

export default SSBadge;
